/**
 * 登入後新建 Square（使用共用表單：商店名稱、類型（選填）→ POST /lite/squares → 導向 /lite/shop/:suffix）
 */

import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { createSquare, switchSquareForJwt } from '../../api/liteSquaresClient';
import { setLiteJwtToken } from '../../api/liteAuthToken';
import { LiteActivityAssistantForm } from '@/components/LiteActivityAssistantForm';
import { getLiteJwtToken } from '../../api/liteAuthToken';

export function SquareCreatePage() {
  const navigate = useNavigate();
  const [formValue, setFormValue] = useState({
    name: '',
    type: '',
    customType: '',
  });
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    const trimmed = formValue.name.trim();
    if (!trimmed) {
      setError('請輸入商店名稱');
      return;
    }

    if (!formValue.type.trim()) {
      setError('請選擇商店類型');
      return;
    }

    const token = getLiteJwtToken();
    if (!token) {
      setError('請先登入');
      navigate('/lite/new-square', { replace: true });
      return;
    }

    setSubmitting(true);
    createSquare(token, trimmed, formValue.type.trim())
      .then(async data => {
        // 換發綁定新 shop 的 JWT，避免訂閱/活動仍用舊 shop 脈絡
        const newToken = await switchSquareForJwt(token, data.suffix);
        setLiteJwtToken(newToken);
        navigate(`/lite/shop/${data.suffix}`, { replace: true });
      })
      .catch(err => {
        setError(err instanceof Error ? err.message : '建立失敗');
        setSubmitting(false);
      });
  };

  return (
    <LiteActivityAssistantForm
      value={formValue}
      onChange={setFormValue}
      onSubmit={handleSubmit}
      submitting={submitting}
      error={error}
      secondaryButton={{
        label: '返回',
        onClick: () => navigate('/lite/square-choice'),
      }}
    />
  );
}
